import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const BulkCreate = loadable(() => import('./BulkCreate'), {});
export const Channel = loadable(() => import('./Channel'), {});
export const Toggle = loadable(() => import('./Toggle'), {});
